export const formatFullName = (...nameParts) => {
  return nameParts
    .filter(Boolean)
    .join(' ')
    .trim();
};